import type { BriefType } from '@/components/FeedCard/BriefIcon/types';
import type { Entity } from './hooks/selector';

const allowedBriefNames = [
  'HasReportedEarnings',
  'HasUpcomingDividend',
  'HasPriceTargetChanged',
  'HasRecentInsiderTransactions',
  'HasNewRisk',
];

type FeedItem = Record<string, Entity>;

export const filterNewsByBriefName = (newsFeed: FeedItem) => {
  return Object.keys(newsFeed).reduce((acc, companyId) => {
    const filteredItems = newsFeed[companyId].feedItems.filter((item) => {
      if (item.briefName !== undefined) {
        return allowedBriefNames.includes(item.briefName);
      }
    });
    if (filteredItems.length > 0) {
      acc[companyId] = {
        ...newsFeed[companyId],
        feedItems: filteredItems,
      };
    }

    return acc;
  }, {});
};

type NewsType = {
  [K in keyof typeof BriefType]: number;
};

export const getTotalPerBriefName = (newsFeed: FeedItem) => {
  return Object.values(newsFeed)
    .map((company) => company.feedItems)
    .flat()
    .reduce((acc, item) => {
      if (item.briefName !== undefined) {
        const briefName = item.briefName;
        acc[briefName] = (acc[briefName] || 0) + 1;
      }
      return acc;
    }, {} as NewsType);
};
